<div class="popup-header">
  <h2 mat-dialog-title class="popup-title">
    <mat-icon aria-hidden="true">archive</mat-icon>
    <span>{{ 'pages.post-it-notes.archive-list.title' | translate }}</span>
  </h2>
  <div class="popup-subtitle">
    {{ 'pages.post-it-notes.archive-list.subtitle' | translate }}
  </div>
</div>
<mat-divider></mat-divider>

@if (data.length > 0) {
<mat-dialog-content style="height: 40vh">
  <span>
    <mat-checkbox
      [checked]="allComplete"
      [indeterminate]="someComplete()"
      (change)="setAll($event.checked)"
    >
      <div class="p-2 select-all-text">
        {{ 'pages.post-it-notes.archive-list.select-all' | translate }}
      </div>
    </mat-checkbox>
  </span>
  <div>
    @for (note of data; track note) {
    <div class="d-flex align-items-center w-100 mb-1">
      <mat-checkbox
        [(ngModel)]="note.selected"
        (ngModelChange)="updateAllComplete()"
      ></mat-checkbox>
      <div
        class="d-flex justify-content-between align-items-center px-3 ml-3 single-item-style"
      >
        <div
          class="single-item-style_title"
          [style]="
            note.selected
              ? 'color: rgba(0, 0, 0, 1);'
              : 'color: rgba(0, 0, 0, 0.5);'
          "
        >
          {{ note.title }}
        </div>
        <div
          class="single-item-style_date"
          [style]="
            (note.selected
              ? 'color: rgba(0, 0, 0, 1);'
              : 'color: rgba(0, 0, 0, 0.5);') + 'font-size: 0.8rem;'
          "
        >
          {{ note.start_date }}
        </div>
      </div>
    </div>
    }
  </div>
</mat-dialog-content>
} @else {
<mat-dialog-content>
  <app-no-results-found></app-no-results-found>
</mat-dialog-content>
}

<mat-dialog-actions
  class="flex-nowrap justify-content-end action-buttons"
  align="end"
  style="padding: 16px 24px"
>
  <button mat-flat-button (click)="onClickCancel()">
    {{ 'pages.post-it-notes.archive-list.cancel-btn' | translate }}
  </button>
  <button
    mat-stroked-button
    [disabled]="!noteChecked"
    (click)="onClickRestore()"
  >
    {{ 'pages.post-it-notes.archive-list.restore-btn' | translate }}
  </button>
  <button
    mat-flat-button
    [disabled]="!noteChecked"
    color="primary"
    (click)="onClickDelete()"
  >
    {{ 'pages.post-it-notes.archive-list.delete-forever-btn' | translate }}
  </button>
</mat-dialog-actions>
